export const SUPPORT_LANGUAGES = {
  FI: 'fi',
  SV: 'sv',
  EN: 'en',
};

export const DEFAULT_LANGUAGE = SUPPORT_LANGUAGES.FI;
